<template>
  <div class="test-questions card">

    <!-- Estado: Cargando -->
    <div v-if="loading" class="loading-state" id="q-loading">
      <div class="spinner"></div>
      <p>Cargando preguntas...</p>
    </div>

    <!-- Estado: Error -->
    <div v-else-if="loadError" class="error-state" id="q-error">
      <p class="error-msg">{{ loadError }}</p>
      <button type="button" class="btn-primary" @click="fetchQuestions">Reintentar</button>
    </div>

    <!-- Estado: Preguntas cargadas -->
    <template v-else-if="QS.length">
      <!-- Intro / Progress -->
      <div class="progress-wrap">
        <div class="progress-top">
          <div class="progress-label" id="q-label">Pregunta {{ cur + 1 }} de {{ QS.length }}</div>
          <div class="progress-counter" id="q-counter">{{ progressPct }}%</div>
        </div>
        <div class="progress-track">
          <div class="progress-fill" id="q-progress" :style="{ width: progressPct + '%' }"></div>
        </div>
      </div>

      <!-- Question -->
      <div class="q-section" id="q-section-label">{{ currentSectionName }}</div>
      <div class="q-text" id="q-text" :class="{ 'err-text': errorMsg }">{{ currentQuestion.t }}</div>

      <div class="options" id="q-options">
        <button
          v-for="(opt, index) in currentQuestion.opts"
          :key="index"
          type="button"
          class="opt-btn"
          :class="{ selected: answers[cur] === index }"
          @click="selectOpt(index)"
        >
          <span class="opt-icon"></span>
          <span>{{ opt.l }}</span>
        </button>
      </div>

      <div class="nav-row">
        <button type="button" class="btn-ghost" id="btn-back" @click="prevQ" :style="{ visibility: cur === 0 ? 'hidden' : 'visible' }">
          ← Anterior
        </button>
        <button type="button" class="btn-primary" id="btn-next" @click="nextQ">
          {{ cur === QS.length - 1 ? 'Ver mis resultados ✓' : 'Siguiente →' }}
        </button>
      </div>
    </template>

  </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js';
export default {
  name: 'TestQuestions',
  data() {
    return {
      cur: 0,
      answers: [],
      errorMsg: false,
      loading: true,
      loadError: null,
      SECTIONS: {
        'R': 'Habilidades técnicas y prácticas',
        'I': 'Investigación y análisis',
        'A': 'Creatividad y expresión',
        'S': 'Relaciones sociales',
        'E': 'Liderazgo y emprendimiento',
        'C': 'Organización y administración',
      },
      QS: []
    };
  },
  computed: {
    currentQuestion() { return this.QS[this.cur] || {}; },
    currentSectionName() { return this.currentQuestion.s ? this.SECTIONS[this.currentQuestion.s] : ''; },
    progressPct() { return this.QS.length ? Math.round(((this.cur + 1) / this.QS.length) * 100) : 0; }
  },
  mounted() {
    this.fetchQuestions();
  },
  methods: {
    async fetchQuestions() {
      this.loading = true;
      this.loadError = null;
      try {
        const result = await IberoHelpers.ObtenerPreguntasTestVocacional(this.$store);
        if (!result || !result.data) {
          throw new Error('Sin respuesta del servidor');
        }
        const data = result.data;
        this.QS = data;
        this.answers = new Array(data.length).fill(null);
        this.cur = 0;
      } catch (err) {
        console.error('Error al cargar las preguntas:', err);
        this.loadError = 'No se pudieron cargar las preguntas. Por favor, inténtalo de nuevo.';
      } finally {
        this.loading = false;
      }
    },
    selectOpt(index) {
      this.$set(this.answers, this.cur, index);
      this.errorMsg = false;
    },
    nextQ() {
      if (this.answers[this.cur] === null) {
        this.errorMsg = true;
        setTimeout(() => { this.errorMsg = false; }, 600);
        return;
      }
      if (this.cur < this.QS.length - 1) {
        this.cur++;
      } else {
        this.calcResults();
      }
    },
    prevQ() {
      if (this.cur > 0) {
        this.cur--;
      }
    },
    calcResults() {
      const scores = { R: 0, I: 0, A: 0, S: 0, E: 0, C: 0 };
      const answersText = [];
      this.answers.forEach((a, qi) => {
        if (a === null) return;
        const opt = this.QS[qi].opts[a];
        scores[this.QS[qi].s] += opt.v;
        if (opt.b) scores[opt.b] += opt.v === 3 ? 1 : 0;
        answersText.push(opt.l);
      });
      const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
      const top1 = sorted[0][0];
      const top2 = sorted[1][0];
      const maxVal = sorted[0][1] || 1;
      const scoreData = { scores, sorted, top1, top2, maxVal };
      this.$emit('test-completed', { scoreData, answersText });
    }
  }
};
</script>

<style scoped>
/* ── Progress ── */
.progress-wrap { margin-bottom: 2rem; }
.progress-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
.progress-label { font-size: 12px; font-weight: 600; color: var(--text-sec); }
.progress-counter { font-size: 12px; font-weight: 700; color: var(--carbon); }
.progress-track { height: 4px; background: #E5E3DB; border-radius: 2px; }
.progress-fill { height: 4px; background: var(--carbon); border-radius: 2px; transition: width 0.4s ease; }

/* ── Question ── */
.q-section { font-size: 11px; font-weight: 700; letter-spacing: 0.1em; color: var(--gold-d); text-transform: uppercase; margin-bottom: 0.6rem; }
.q-text { font-size: 19px; font-weight: 700; color: var(--carbon); line-height: 1.4; margin-bottom: 1.75rem; transition: color 0.2s; }
.err-text { color: #E24B4A !important; }
.options { display: flex; flex-direction: column; gap: 10px; }
.opt-btn { background: var(--white); border: 1.5px solid var(--border); border-radius: 12px; padding: 14px 18px; text-align: left; cursor: pointer; font-family: 'Montserrat', sans-serif; font-size: 14px; color: var(--carbon); display: flex; align-items: flex-start; gap: 12px; transition: border-color 0.15s, background 0.15s; line-height: 1.5; }
.opt-btn:hover { border-color: var(--gold); background: var(--gold-bg); }
.opt-btn.selected { border: 2px solid var(--carbon); background: var(--gold-bg); font-weight: 600; }
.opt-icon { width: 22px; height: 22px; border-radius: 50%; border: 1.5px solid #C8C6BE; flex-shrink: 0; margin-top: 1px; transition: 0.15s; display: flex; align-items: center; justify-content: center; }
.opt-btn.selected .opt-icon { background: var(--carbon); border-color: var(--carbon); }
.opt-btn.selected .opt-icon::after { content: ''; width: 8px; height: 8px; background: var(--white); border-radius: 50%; }
.nav-row { display: flex; justify-content: space-between; align-items: center; margin-top: 1.5rem; }

/* ── Buttons ── */
.btn-primary{background:var(--carbon);color:var(--white);border:none;padding:14px 32px;border-radius:10px;font-family:'Montserrat',sans-serif;font-size:14px;font-weight:700;cursor:pointer;transition:background .2s,transform .1s;letter-spacing:.02em}
.btn-primary:hover{background:#333}
.btn-primary:active{transform:scale(.98)}
.btn-primary:disabled{opacity:.5;cursor:not-allowed}
.btn-ghost{background:transparent;color:var(--text-sec);border:none;padding:12px 18px;font-family:'Montserrat',sans-serif;font-size:14px;cursor:pointer}
.btn-ghost:hover{color:var(--carbon)}

/* ── Loading & Error ── */
.loading-state,
.error-state { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 3rem 1rem; gap: 1rem; text-align: center; color: var(--text-sec); }
.error-msg { color: #E24B4A; font-size: 15px; font-weight: 600; }
.spinner { width: 40px; height: 40px; border: 3px solid #E5E3DB; border-top-color: var(--carbon); border-radius: 50%; animation: spin 0.7s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }

@media(max-width: 520px) {
  .q-text { font-size: 16px; }
}
</style>
